import type { JSX, MouseEventHandler } from 'react';
import { Link } from 'react-scroll';

const defaultScrollOffset = -32;

const useScrollableLink = () => {
  const get = (
    title: string | JSX.Element,
    link: string,
    onClick: (link: string) => void & MouseEventHandler<HTMLButtonElement>,
    scrollOffset: number = defaultScrollOffset,
    className?: string,
    isActive?: boolean
  ) => {
    const scrollDuration = 850;
    const scrollSpyThrottle = 50;

    const currentClass = `${isActive ? 'active' : ''} ${className ?? ''}`.trim();

    const onLinkClick = () => {
      onClick(link);
    };

    return (
      <Link
        activeClass="active"
        className={currentClass}
        href={link}
        to={link}
        spy={true}
        smooth={true}
        offset={scrollOffset}
        duration={scrollDuration}
        ignoreCancelEvents={false}
        spyThrottle={scrollSpyThrottle}
        onClick={onLinkClick}
      >
        {title}
      </Link>
    );
  };

  return { get };
};

export { defaultScrollOffset, useScrollableLink };
